import React from "react";
import { TaskGroupView, TaskRowView } from "../viewmodels/buildTaskGroups";
import { TaskRow } from "./TaskRow";

interface TaskGroupProps {
  group: TaskGroupView;
  onSelectRow: (row: TaskRowView) => void;
}

/**
 * A titled block of task rows: Invoices, Bills, Bank, Queries or Journals.
 */
export const TaskGroup: React.FC<TaskGroupProps> = ({ group, onSelectRow }) => {
  const Icon = group.icon;

  return (
    <section className="flex w-full flex-col items-start gap-1">
      <div className="flex w-full items-center gap-2 pb-2">
        <Icon className="text-heading-3 font-heading-3 text-neutral-500" />
        <h2 className="text-heading-3 font-heading-3 text-default-font">
          {group.title}
        </h2>
      </div>

      <div className="flex w-full flex-col items-start">
        {group.rows.map((row) => (
          <TaskRow key={row.id} row={row} onSelect={onSelectRow} />
        ))}
      </div>
    </section>
  );
};
